/* eslint-disable react/prop-types */
import React from 'react';
import { Card, Col, Row, Tab, Nav } from 'react-bootstrap';

import { get, isEmpty } from 'lodash';
import Enviroment from 'assets/img/icons/Enviroment.svg';
import SimpleBarReact from 'simplebar-react';
import classNames from 'classnames';
import CardSkeleton from 'components/common/skeleton/CardSkeleton';
import TabTitle from 'components/common/TabTitle';
import LeafletMap from 'components/common/map/LeafletMap';
import SurfaceSoilMoisture from './charts/SurfaceSoilMoisture';
import HumidityChart from './charts/HumidityChart';
import FireIncidentsMap from './maps/FireIncidentsMap';
import WidgetSectionTitle from 'widgets/CustomWidgetSectionTitle';
import AirQuality from './charts/AirQuality';

const EnvironmentParameters = ({
  getEnvironmentologyEvaluationAPI,
  environmentologyObservation,
  coordinates
}) => {
  const mapData = {
    title: get(environmentologyObservation, 'burnt_area[0].label', ''),
    tifUrl: get(environmentologyObservation, 'burnt_area[0].url', ''),
    info: get(environmentologyObservation, 'burnt_area[0].info', ''),
    key: 'fire-event-map'
  };
  const environmentData = [];

  environmentData.push({
    title: get(
      environmentologyObservation,
      'carbon_flux_emission[0].label',
      ''
    ),
    tifUrl: get(environmentologyObservation, 'carbon_flux_emission[0].url', ''),
    info: get(environmentologyObservation, 'carbon_flux_emission[0].info', ''),
    key: 'carbon_flux_emission-map'
  });

  environmentData.push({
    title: get(environmentologyObservation, 'carbon_flux_removal[0].label', ''),
    tifUrl: get(environmentologyObservation, 'carbon_flux_removal[0].url', ''),
    info: get(environmentologyObservation, 'carbon_flux_removal[0].info', ''),
    key: 'carbon_flux_removal-map'
  });

  environmentData.push({
    title: get(environmentologyObservation, 'carbon_net_flux[0].label', ''),
    tifUrl: get(environmentologyObservation, 'carbon_net_flux[0].url', ''),
    info: get(environmentologyObservation, 'carbon_net_flux[0].info', ''),
    key: 'carbon_net_flux-map'
  });

  return (
    <>
      <WidgetSectionTitle
        icon={Enviroment}
        title="Environment Parameters"
        transform="shrink-4"
        className="mb-4 mt-4 align-items-center"
      />

      <Row className="g-3 mb-3">
        <Col lg={12}>
          {getEnvironmentologyEvaluationAPI.loading ? (
            <CardSkeleton />
          ) : (
            <Card className={classNames('mb-3', 'overflow-hidden')}>
              <Tab.Container
                id="environment-tab"
                defaultActiveKey={environmentData[0].key}
              >
                <SimpleBarReact>
                  <Card.Header className="p-0 bg-light">
                    <Nav className="nav-tabs border-0 flex-nowrap chart-tab">
                      {environmentData.map(item => (
                        <Nav.Item key={item.key}>
                          <Nav.Link className="mb-0" eventKey={item.key}>
                            <TabTitle value={item.title} />
                          </Nav.Link>
                        </Nav.Item>
                      ))}
                    </Nav>
                  </Card.Header>
                </SimpleBarReact>

                <Card.Body className="p-0">
                  <Tab.Content>
                    {environmentData.map((item, index) => (
                      <Tab.Pane
                        key={item.key}
                        unmountOnExit
                        eventKey={item.key}
                      >
                        <LeafletMap
                          data={{
                            coordinates: coordinates,
                            mapData: item
                          }}
                          className="h-100 bg-white"
                          style={{ minHeight: '410px' }}
                          key={`${item.key}-${index}-land-locations`}
                        />
                        <Card.Footer className="bg-white py-2 card-footer-style">
                          <h5 className="mb-0 infrence-info">{item.info}</h5>
                        </Card.Footer>
                      </Tab.Pane>
                    ))}
                  </Tab.Content>
                </Card.Body>
              </Tab.Container>
            </Card>
          )}
        </Col>
        <Col lg={12}>
          {isEmpty(environmentologyObservation) ||
          getEnvironmentologyEvaluationAPI.loading ? (
            <CardSkeleton />
          ) : (
            <AirQuality
              environmentologyObservation={environmentologyObservation}
              className="mb-3 h-100"
            />
          )}
        </Col>
        <Col lg={6}>
          {isEmpty(environmentologyObservation) ||
          getEnvironmentologyEvaluationAPI.loading ? (
            <CardSkeleton />
          ) : (
            <HumidityChart
              environmentologyObservation={environmentologyObservation}
            />
          )}
        </Col>
        <Col lg={6}>
          {isEmpty(environmentologyObservation) ||
          getEnvironmentologyEvaluationAPI.loading ? (
            <CardSkeleton />
          ) : (
            <SurfaceSoilMoisture
              environmentologyObservation={environmentologyObservation}
            />
          )}
        </Col>
        <Col lg={12}>
          {isEmpty(mapData) || getEnvironmentologyEvaluationAPI.loading ? (
            <CardSkeleton />
          ) : (
            <FireIncidentsMap data={mapData} coordinates={coordinates} />
          )}
        </Col>
      </Row>
    </>
  );
};

export default EnvironmentParameters;
